import { Action } from '../../actions';
import { StoreState } from '../../reducers';
import { Dispatch } from 'react-redux';
import { DriveItemOrigin, getOrFetchDriveItemMeta, viewDriveItem } from '../DriveItemList/actions';
import { Api } from '../../typings/api';

enum BackToPublicationActionKeys {
	SET_LAST_PUBLICATION = '@@BackToPublication/SET_LAST_PUBLICATION',
}

type BackToPublicationAction = SetLastPublicationAction;

interface SetLastPublicationAction extends Action {
	type: BackToPublicationActionKeys.SET_LAST_PUBLICATION;
	publicationId: number;
	page?: number;
}

const setLastPublication = (publicationId: number, page: number | undefined) =>
	(dispatch: Dispatch<StoreState>): void => {
		const action: SetLastPublicationAction = {
			type: BackToPublicationActionKeys.SET_LAST_PUBLICATION,
			publicationId,
			page,
		};
		dispatch(action);
	};

const resumeLastPublication = (publicationId: number, page: number | undefined) =>
	(dispatch: Dispatch<StoreState>): void => {
		dispatch(getOrFetchDriveItemMeta(publicationId))
			.then((driveItem: Api.DriveItem) => {
				dispatch(viewDriveItem(driveItem, DriveItemOrigin.Menu, {
					page,
					hideWelcomePage: true
				}));
			});
	};

export { BackToPublicationActionKeys, BackToPublicationAction, setLastPublication, resumeLastPublication };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/BackToPublication/actions.ts